import React from "react";
import PageHero from "@/components/shared/PageHero";
import EditorialMarquee from "@/components/sections/Marquee";
import Manifesto from "@/components/sections/Manifesto";
import Statistics from "@/components/sections/Statistics";
import Initiatives from "@/components/sections/Initiatives";

export default function About() {
    return (
        <>
            <PageHero
                testId="about-page"
                eyebrow="About"
                chapter="Chapter · 00"
                title="Designed as a public good."
                subtitle="A concept prototype exploring how citizen engagement could look if built with the care of a modern digital product."
            />
            <EditorialMarquee />
            <Manifesto />
            <Statistics />
            <Initiatives />
        </>
    );
}
